import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import { injectIntl, FormattedMessage } from 'react-intl';

import DateRange from '../DateRange';
import CurrencyConverter from '../../CurrencyConverter';
import BillDetails from './BillDetails';
import BookingButton from './BookingButton';
import moment from 'moment'
import TimeField from '../TimeField';
import CustomCheckbox from '../../CustomCheckbox';

import messages from '../../../locale/messages';
import { bookingProcess } from '../../../actions/booking/bookingProcess';
import { generateTimes } from '../../../helpers/formatting';
import { fetchExcessInsurancePrice } from '../../../actions/excessInsuranceQuote';

import miniBus from '/public/siteImages/minibus.svg';

import { AiOutlineExclamationCircle } from "react-icons/ai";

import s from './Calendar.css';
import cs from '../../../components/commonStyle.css';

import SwitchButton from 'react-switch';

// Add this import with other imports
import ExcessInsuranceModal from '../../ExcessInsuranceModal/ExcessInsuranceModal';
import dayDifferenceHelper from '../../../helpers/dayDifferenceHelper';
import InsurancePlanFeaturesModal from '../../InsurancePlanFeaturesModal/InsurancePlanFeaturesModal';
import { EXCESS_INSURANCE_AGE } from '../../../constants';

class BookingForm extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    personCapacity: PropTypes.number.isRequired,
    basePrice: PropTypes.number.isRequired,
    delivery: PropTypes.number,
    currency: PropTypes.string,
    monthlyDiscount: PropTypes.number,
    weeklyDiscount: PropTypes.number,
    minDay: PropTypes.number,
    maxDay: PropTypes.number,
    maxDaysNotice: PropTypes.string,
    loading: PropTypes.bool,
    availability: PropTypes.bool,
    maximumStay: PropTypes.bool,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    blockedDates: PropTypes.array,
    isHost: PropTypes.bool.isRequired,
    guests: PropTypes.number,
    serviceFees: PropTypes.shape({
      guest: PropTypes.shape({
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    base: PropTypes.string.isRequired,
    rates: PropTypes.object.isRequired,
    bookingType: PropTypes.string.isRequired,
    bookingLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userBanStatus: PropTypes.number,
    }),
    // fetchExcessInsurancePrice: PropTypes.func
  };

  // In constructor, add insuranceDuration to state
  constructor(props) {
      super(props);
      this.state = {
        includeDelivery: false,
        insuranceDuration: '',
        showExcessInsuranceModal: false,
        showInsurancePlanFeaturesModal: false ,
        insurancePriceLoading: false,
        insurancePriceError: null // Add this line
      }
  }

  static defaultProps = {
    blockedDates: [],
    availability: true,
    maximumStay: false,
    minimumStay: false,
    startDate: null,
    endDate: null,
    guests: 1,
    personCapacity: 0,
  };

  componentDidMount() {
    const { URLRoomType, roomType, change } = this.props;
    this.setState({ includeDelivery: URLRoomType == "true" ? true : false })
    change('roomType', URLRoomType == "true" ? true : false)
  }

  renderFormControlSelect({ input, label, meta: { touched, error }, children, className }) {
    return (
      <div className={'inputFocusColor'}>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    );
  }

  renderGuests(personCapacity) {
    const { formatMessage } = this.props.intl;
    const rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(<option key={i} value={i}>{i} {i > 1 ? formatMessage(messages.guests) : formatMessage(messages.guest)}</option>);
    }
    return rows;
  }

  handleCheckBox = (event) => {
    const { change } = this.props;
    const { includeDelivery } = this.state;
    this.setState({ includeDelivery: !includeDelivery });
    change('roomType', event);
  }
  checkboxHorizontalGroup = ({ label, labelSmall }) => {
    const { delivery, currency, roomType } = this.props

    return (
      <div className={s.doorStepSection}>
        <div className={cx(s.doorStepImageSection, cs.displayFlex, cs.alignCenter, 'doorStepImageRTL')}>
          <img src={miniBus} className={s.doorStepImage} />
        </div>
        <div className={cx(s.doorStepText, 'doorStepRTL')}>
          <div>
            <p className={cs.commonMediumText}>{label}</p>
            <p className={cx(cs.commonSmallText, cs.siteLinkColor)}>({labelSmall}{' '}-{' '}{<CurrencyConverter amount={delivery} from={currency} />})</p>
          </div>
          <CustomCheckbox
            className={'icheckbox_square-green'}
            onChange={event => {
              this.handleCheckBox(event);
            }}
            checked={roomType}
            value={true}
          />
        </div>
      </div>
    )
  };


  // Add this method before render

  handleInsuranceSwitch = async (checked) => {
    const { fetchExcessInsurancePrice, id, startDate, endDate, dispatch } = this.props;
    if (checked) {
      this.setState({ insurancePriceLoading: true, insurancePriceError: null });
      try {
        const days = (startDate && endDate) ? dayDifferenceHelper({ startDate, endDate, startTime: this.props.startTime, endTime: this.props.endTime }) : 1;
        const variables = {
          listId: id,
          days,
          age: EXCESS_INSURANCE_AGE,
          userId: id ? String(id) : undefined,
          userEmail: this.props.account?.email,
          currency: this.props.currency || this.props.base || 'USD'
        };
        const priceObj = await fetchExcessInsurancePrice(variables);
        let price = null;
        if (priceObj && typeof priceObj === 'object') {
          price = priceObj.daily || priceObj.monthly || priceObj.annual || null;
        } else {
          price = priceObj;
        }
        this.setState({ includeInsurance: true, insurancePrice: price, insurancePriceLoading: false });
      } catch (error) {
        this.setState({ insurancePriceError: 'Failed to fetch insurance price', insurancePriceLoading: false, includeInsurance: false });
      }
    } else {
      // Toggling OFF
      this.setState({ includeInsurance: false, insurancePrice: null, insurancePriceError: null });
    }
  }

  // handleInsuranceSwitch = () => {
  //   this.setState(prevState => ({
  //     includeInsurance: !prevState.includeInsurance
  //   }));
  // }
  // Add this method before render
  handleInsuranceDurationChange = (e) => {
    this.setState({ insuranceDuration: e.target.value });
  }

  // Add this method after handleInsuranceDurationChange
  toggleExcessInsuranceModal = () => {
    this.setState(prevState => ({
      showExcessInsuranceModal: !prevState.showExcessInsuranceModal
    }));
  }

  // Add this method after toggleExcessInsuranceModal
  toggleInsurancePlanFeaturesModal = () => {
    this.setState(prevState => ({
      showInsurancePlanFeaturesModal: !prevState.showInsurancePlanFeaturesModal
    }));
  }

  render() {
    const { includeDelivery, includeInsurance, insuranceSelected, insuranceExcessValue, insurancePrice, insuranceType } = this.state;
    const { formatMessage } = this.props.intl;
    const { id, basePrice, delivery, currency, isHost, bookingType } = this.props;
    const { monthlyDiscount, weeklyDiscount, minDay, maxDay, maxDaysNotice, securityDeposit } = this.props;
    const { isLoading, availability, maximumStay, guests, startDate, endDate, account, blockedDates, minimumStay } = this.props;
    const { bookingProcess, serviceFees, base, rates, bookingLoading, startTime, endTime } = this.props;
    const { roomType, bookingLoader } = this.props;
    const isDateChosen = startDate != null && endDate != null || false;
    let userBanStatusValue, deliveryFee, deliveryStatus, isTimeChosen;
    let momentStartDate, momentEndDate, dayDifference, isDisabled = false, isValue = true;
    let isToday = false, startTimeLookup, endTimeLookup;

    if (account) {
      const { account: { userBanStatus } } = this.props;
      userBanStatusValue = userBanStatus;
    }

    if (includeDelivery) {
      deliveryFee = delivery
      deliveryStatus = 'include'
    } else {
      deliveryFee = 0
      deliveryStatus = 'exclude'
    }

    momentStartDate = moment(startDate);
    momentEndDate = moment(endDate);
    dayDifference = momentEndDate.diff(momentStartDate, 'days');

    isTimeChosen = isNaN(startTime) || isNaN(endTime) ? false : true;

    if ((startTime >= endTime) && dayDifference == 0) {
      isValue = false;
      isDisabled = true;
    }
    if (!isTimeChosen) {
      isDisabled = true;
    } else if (!isDateChosen) {
      isDisabled = true;
    }

    startTimeLookup = generateTimes(0, 1410, isToday);
    endTimeLookup = generateTimes(0, 0);

    if (momentStartDate) {
      isToday = moment(moment(momentStartDate)).isSame(moment(), 'day');
      startTimeLookup = generateTimes(0, 1410, isToday);
    }

    if (momentEndDate) {
      isToday = moment(moment(momentEndDate)).isSame(moment(), 'day');
      endTimeLookup = generateTimes(0, 0, isToday);
    }

    return (
      <Form>
        <FormGroup className={cs.spaceBottom4}>
          <label>
            <FormattedMessage {...messages.dates} />
          </label>
          <span className={cx('viewListingDate')}>
            <DateRange
              listId={id}
              minimumNights={minDay}
              maximumNights={maxDay}
              blockedDates={blockedDates}
              formName={'BookingForm'}
              maxDaysNotice={maxDaysNotice}
              startTime={startTime}
              endTime={endTime}
            />
          </span>
        </FormGroup>
        <FormGroup className={cs.spaceBottom4}>
          <label>{formatMessage(messages.startLabel)}</label>
          <div className={s.displayGrid}>
            <TimeField
              name={"startTime"}
              className={cs.formControlSelect}
              TimeLookup={startTimeLookup}
              formName={"BookingForm"}
              label={formatMessage(messages.tripStart)}
              listId={id}
              startDate={startDate}
              endDate={endDate}
              startTime={startTime}
              endTime={endTime}
              maximumNights={maxDay}
              value={startTime}
              minimumNights={minDay}
              classNameParent={cx(s.paddingRight, 'calendarPaddingRightRTL')}
            />
            <TimeField
              name={"endTime"}
              className={cs.formControlSelect}
              TimeLookup={endTimeLookup}
              formName={"BookingForm"}
              label={formatMessage(messages.tripEnd)}
              listId={id}
              startDate={startDate}
              endDate={endDate}
              startTime={startTime}
              endTime={endTime}
              maximumNights={maxDay}
              value={endTime}
              minimumNights={minDay}
              classNameParent={cx(s.paddingLeft, 'calendarPaddingLeftRTL')}
            />
          </div>
        </FormGroup>
        {
          (delivery != null || delivery != undefined) && Number(delivery) > 0 &&
          <FormGroup className={cs.spaceBottom3}>
            <Field
              name="roomType"
              component={this.checkboxHorizontalGroup}
              label={formatMessage(messages.doorstepDelivery)}
              labelSmall={formatMessage(messages.deliveryCharges)}
            />
          </FormGroup>
        }
        <FormGroup>
          {
            !isLoading && maximumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.maximumStay} /> {maxDay} {maxDay > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }
          {
            !isLoading && minimumStay && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.minimumStayText} /> {minDay} {minDay > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
              </p>
            </div>
          }

          {
            !isLoading && !availability && isDateChosen && !userBanStatusValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}>
                <FormattedMessage {...messages.hostErrorMessage2} />
              </p>
            </div>
          }
          {
            isTimeChosen && !isValue && <div className={cx(s.bookItMessage, cs.spaceTop1)}>
              <p className={cx(s.noMargin, s.textCenter, s.textError)}><FormattedMessage {...messages.youMustChooseTime} /></p>
            </div>
          }
        </FormGroup>
        {
          !bookingLoader && !maximumStay && !minimumStay && availability && isDateChosen && !userBanStatusValue && isTimeChosen && isValue && <BillDetails
            basePrice={basePrice}
            delivery={deliveryFee}
            currency={currency}
            monthlyDiscount={monthlyDiscount}
            weeklyDiscount={weeklyDiscount}
            startDate={startDate}
            endDate={endDate}
            serviceFees={serviceFees}
            base={base}
            rates={rates}
            securityDeposit={securityDeposit}
            insurancePrice={this.state.includeInsurance && this.state.insurancePrice ? Number(this.state.insurancePrice) : 0}
          />
        }
 <div className={cx(s.insuranceContainer)}>

<div className={cx(s.insuranceSwitchContainer)}>
  <div className={cx(s.insuranceText)}>
    <span>Excess Insurance</span>

    <div 
      className={cx(s.insuranceBtn)}
      onClick={this.toggleExcessInsuranceModal}
    >
      <AiOutlineExclamationCircle />
    </div> 
    
  </div>
  <div className={cx(cs.displayFlex)}>
    <SwitchButton
      checked={includeInsurance}
      onChange={this.handleInsuranceSwitch}
      offColor="#ADBBC7"
      onColor="#4682B4"
      height={26}
      width={50}
      handleDiameter={18}
      boxShadow="none"
    />
  </div>
  
</div>
<div className={cx(s.insurancePrice)}>
  {this.state.insurancePriceLoading && <span>Loading...</span>}
  {this.state.insurancePriceError && <span style={{ color: 'red' }}>{this.state.insurancePriceError}</span>}
  {!this.state.insurancePriceLoading && !this.state.insurancePriceError && (
    <CurrencyConverter
      amount={
        isNaN(Number(this.state.insurancePrice)) || this.state.insurancePrice === '' || this.state.insurancePrice === null
          ? 0
          : Number(this.state.insurancePrice)
      }
      from={this.props.base}
      toCurrency={this.props.currency || (this.state.insurancePrice && this.state.insurancePrice.currency) || 'USD'}
      base={this.props.base}
      rates={this.props.rates}
    />
  )}
</div>
</div>
        {/* <div className={cx(s.insuranceContainer)}>

          <div className={cx(s.insuranceSwitchContainer)}>
            <div className={cx(s.insuranceText)}>
              <span>Excess Insurance</span>
              <div 
                className={cx(s.insuranceBtn)}
                onClick={this.toggleExcessInsuranceModal}
              >
                <AiOutlineExclamationCircle />
              </div> 
            </div>
            <div className={cx(cs.displayFlex)}>
              <SwitchButton
                checked={includeInsurance}
                onChange={this.handleInsuranceSwitch}
                offColor="#ADBBC7"
                onColor="#4682B4"
                height={26}
                width={50}
                handleDiameter={18}
                boxShadow="none"
              />
            </div>
          </div>
          
          <div className={cx(s.insuranceDuration)}>
            <label>Insurance Duration</label>
            <div className={'inputFocusColor'}>
              <FormControl
                componentClass="select"
                className={cs.formControlSelect}
                value={this.state.insuranceDuration}
                onChange={this.handleInsuranceDurationChange}
              >
                <option value="">Select insurance duration</option>
                <option value="daily">Daily</option>
                <option value="annual">Annual</option>
                <option value="worldwide">Worldwide Annual</option>
              </FormControl>
            </div>
          </div>

          <div className={cx(s.insurancePlanContainer)}>
            <label>Choose Your Excess Insurance Plan</label>
            <div className={cx(s.insurancePlanList)}>
              <div className={cx(s.insurancePlanItem)}>
                 <div className={cx(s.insuranceRadio)}><Field name="bookingType" component="input" type="radio" value="check1" className={s.insuranceInput} /></div>
                 <div className={cx(s.insurancePlanInfo)}>
                    <div className={cx(s.insurancePlanTop)}>
                      <div className={cx(s.insurancePlanText)}>US$ 266.57</div>
                      <div 
                        className={cx(s.insurancePlanBtn)}
                        onClick={this.toggleInsurancePlanFeaturesModal}
                      >
                        <AiOutlineExclamationCircle className={cx(s.icon)} />
                      </div>
                    </div>
                    <p className={cx(s.insurancePlanContent)}>Single Trip: Enjoy global coverage with your US$2500 excess waived.</p>
                 </div>
              </div>
              <div className={cx(s.insurancePlanItem)}>
                 <div className={cx(s.insuranceRadio)}><Field name="bookingType" component="input" type="radio" value="check2" className={s.insuranceInput} /></div>
                 <div className={cx(s.insurancePlanInfo)}>
                    <div className={cx(s.insurancePlanTop)}>
                      <div className={cx(s.insurancePlanText)}>US$ 266.57</div>
                      <div className={cx(s.insurancePlanBtn)}><AiOutlineExclamationCircle className={cx(s.icon)} /></div>
                    </div>
                    <p className={cx(s.insurancePlanContent)}>Single Trip: Enjoy global coverage with your US$2500 excess waived.</p>
                 </div>
              </div>
              <div className={cx(s.insurancePlanItem)}>
                 <div className={cx(s.insuranceRadio)}><Field name="bookingType" component="input" type="radio" value="check3" className={s.insuranceInput} /></div>
                 <div className={cx(s.insurancePlanInfo)}>
                    <div className={cx(s.insurancePlanTop)}>
                      <div className={cx(s.insurancePlanText)}>US$ 266.57</div>
                      <div className={cx(s.insurancePlanBtn)}><AiOutlineExclamationCircle className={cx(s.icon)} /></div>
                    </div>
                    <p className={cx(s.insurancePlanContent)}>Single Trip: Enjoy global coverage with your US$2500 excess waived.</p>
                 </div>
              </div>
            </div>
          </div>

        </div> */}

        <BookingButton
          listId={id}
          startDate={startDate}
          endDate={endDate}
          guests={!isNaN(guests) ? guests : 1}
          bookingProcess={bookingProcess}
          availability={availability}
          isDateChosen={isDateChosen}
          userBanStatus={userBanStatusValue}
          basePrice={basePrice}
          isHost={isHost}
          bookingType={bookingType}
          bookingLoading={bookingLoading}
          maximumStay={maximumStay}
          isDisabled={isDisabled}
          startTime={startTime}
          endTime={endTime}
          deliveryStatus={deliveryStatus}
          roomType={roomType}
          // Pass all insurance fields
          insuranceSelected={!!this.state.includeInsurance}
          insuranceExcessValue={this.state.includeInsurance ? 2000 : 0}
          insurancePrice={this.state.includeInsurance && this.state.insurancePrice ? Number(this.state.insurancePrice) : 0}
          insuranceType={this.state.includeInsurance ? 'daily' : ''}
          userId={this.props.userId}

        />
        
        <ExcessInsuranceModal
          show={this.state.showExcessInsuranceModal}
          onClose={this.toggleExcessInsuranceModal}
        />

        <InsurancePlanFeaturesModal
          show={this.state.showInsurancePlanFeaturesModal}
          onClose={this.toggleInsurancePlanFeaturesModal}
        />
      </Form>
    );
  }
}
BookingForm = reduxForm({
  form: 'BookingForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(BookingForm);



const selector = formValueSelector('BookingForm');

const mapState = state => ({
  isLoading: state?.viewListing?.isLoading,
  availability: state?.viewListing?.availability,
  maximumStay: state?.viewListing?.maximumStay,
  minimumStay: state?.viewListing?.minimumStay,
  startDate: selector(state, 'startDate'),
  endDate: selector(state, 'endDate'),
  guests: Number(selector(state, 'guests')),
  account: state?.account?.data,
  serviceFees: state?.book?.serviceFees,
  base: state?.currency?.base,
  rates: state?.currency?.rates,
  bookingLoading: state?.book?.bookingLoading,
  startTime: Number(selector(state, 'startTime')),
  endTime: Number(selector(state, 'endTime')),
  roomType: selector(state, 'roomType'),
  insuranceSelected: state?.book?.insuranceSelected,
  insuranceExcessValue: state?.book?.insuranceExcessValue,
  insurancePrice: state?.book?.insurancePrice,
  insuranceType: state?.book?.insuranceType,
  userId: state.account.data && state.account.data.userId,

});
const mapDispatch = {
  bookingProcess,
  fetchExcessInsurancePrice
};
export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(BookingForm)));